export default function formatCurrencyAmount(val) {
  let format = {
    style: "currency",
    currency: "GBP"
  };

  return val.toLocaleString("en-Uk", format);
}
